import {BladePanoramicImagesRepository,  WorkInterventionsPanoramicRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    item: {}
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    item (state, data) {
      state.item = {}
      state.item = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladePanoramicImagesRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get ({ commit }, id) {
      return new Promise((resolve, reject) => {
        BladePanoramicImagesRepository.get(id)
          .then(response => {
            const data = response.data.data
            commit('item', data)
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        BladePanoramicImagesRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {      
      return new Promise((resolve, reject) => {
        BladePanoramicImagesRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, params) {
      return new Promise((resolve, reject) => {
        BladePanoramicImagesRepository.delete(params.id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    uploadFile (context, upload) {
      const formData = new FormData();
      formData.append('panoramic_image', upload.fileToUpload)
      upload.file = formData
      console.log("uploadFile -> upload", upload)

      return new Promise((resolve, reject) => {
        WorkInterventionsPanoramicRepository.uploadFile(upload)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
    deleteFile (context, file) {
      return new Promise((resolve, reject) => {
        WorkInterventionsPanoramicRepository.deleteFile(file)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
  }
}
